<div [style.height]="gapHeight + 'px'" class="w-100 bg-primary"></div>
